// 34 个 SVG 通过 ?raw 内联到 bundle；运行期通过 name 取
import addRaw from './svgs/add.svg?raw';
import addImageRaw from './svgs/add-image.svg?raw';
import arrowRightRaw from './svgs/arrow-right.svg?raw';
import checkRaw from './svgs/check.svg?raw';
import checkCircleRaw from './svgs/check-circle.svg?raw';
import chevronDownRaw from './svgs/chevron-down.svg?raw';
import closeRaw from './svgs/close.svg?raw';
import compassRaw from './svgs/compass.svg?raw';
import downloadRaw from './svgs/download.svg?raw';
import editRaw from './svgs/edit.svg?raw';
import errorRaw from './svgs/error.svg?raw';
import filterRaw from './svgs/filter.svg?raw';
import folderRaw from './svgs/folder.svg?raw';
import gridRaw from './svgs/grid.svg?raw';
import historyRaw from './svgs/history.svg?raw';
import imageRaw from './svgs/image.svg?raw';
import infoRaw from './svgs/info.svg?raw';
import listRaw from './svgs/list.svg?raw';
import monitorRaw from './svgs/monitor.svg?raw';
import moonRaw from './svgs/moon.svg?raw';
import moreRaw from './svgs/more.svg?raw';
import playSquareRaw from './svgs/play-square.svg?raw';
import refreshRaw from './svgs/refresh.svg?raw';
import searchRaw from './svgs/search.svg?raw';
import settingsRaw from './svgs/settings.svg?raw';
import sidebarCollapseRaw from './svgs/sidebar-collapse.svg?raw';
import sunRaw from './svgs/sun.svg?raw';
import telescopeRaw from './svgs/telescope.svg?raw';
import trashRaw from './svgs/trash.svg?raw';
import uploadRaw from './svgs/upload.svg?raw';
import uploadVideoRaw from './svgs/upload-video.svg?raw';
import userRaw from './svgs/user.svg?raw';
import vectorRaw from './svgs/vector.svg?raw';
import warningRaw from './svgs/warning.svg?raw';

export const ICONS = {
  add: addRaw,
  addImage: addImageRaw,
  arrowRight: arrowRightRaw,
  check: checkRaw,
  checkCircle: checkCircleRaw,
  chevron: chevronDownRaw,
  close: closeRaw,
  compass: compassRaw,
  download: downloadRaw,
  edit: editRaw,
  error: errorRaw,
  filter: filterRaw,
  folder: folderRaw,
  grid: gridRaw,
  history: historyRaw,
  image: imageRaw,
  info: infoRaw,
  list: listRaw,
  monitor: monitorRaw,
  moon: moonRaw,
  more: moreRaw,
  video: playSquareRaw,
  refresh: refreshRaw,
  search: searchRaw,
  settings: settingsRaw,
  collapse: sidebarCollapseRaw,
  sun: sunRaw,
  telescope: telescopeRaw,
  trash: trashRaw,
  upload: uploadRaw,
  uploadVideo: uploadVideoRaw,
  user: userRaw,
  object: vectorRaw,
  warning: warningRaw,
} as const;

export type IconName = keyof typeof ICONS;
